import {assert} from 'assert-ts';
import type {DataValue, Part} from 'schemaDefinition/types';

export const mapValueGetter = (part: Part, value: DataValue) => {
  assert(!Array.isArray(part), 'mapValueGetter: part is array');

  /**
   * Date values can only be one value.
   */
  const firstDateValue = Array.isArray(value) ? value?.[0] : value;

  switch (part.type) {
    case 'date':
      if (typeof firstDateValue === 'number') {
        return new Date(firstDateValue);
      }
      if (typeof firstDateValue === 'string') {
        return new Date(firstDateValue);
      }

      return undefined;
    case 'year':
      return Number(value);
    default:
      return value;
  }
};
